define('app',['require','ns','api','constant','config','core/i18n','core/loader','core/logger','mapi','utils','ctrl/home/home-v2','ctrl/web-view/article-details','ctrl/member/member-reset-password','ctrl/member/member-reset-password-result','ctrl/member/member-registration-verification'],function (require) {
	'use strict';

	var ns = require('ns');

	var Api = require('api');
	var Constant = require('constant');
	var Config = require('config');
	var I18n = require('core/i18n');
	var Loader = require('core/loader');
	var Logger = require('core/logger');
        var Mapi = require('mapi');

	var utils = require('utils');
        
	var ctrlList = {
		HomeV2: require('ctrl/home/home-v2'),
		WebViewArticleDetails: require('ctrl/web-view/article-details'),
        MemberResetPassword: require('ctrl/member/member-reset-password'),
        MemberResetPasswordResult: require('ctrl/member/member-reset-password-result'),
		MemberRegistrationVerification: require('ctrl/member/member-registration-verification')
	};

	var App = function () {

		this._onLoad();
	};

	App.prototype = {

		_onLoad: function () {

			ns.constant = new Constant();
			ns.config = new Config();

			ns.logger = new Logger();
			ns.i18n = new I18n();

			ns.utils = utils;
			
			ns.loader = new Loader();
			ns.api = new Api();
                        ns.mapi = new Mapi();
			
			$(document).ready($.proxy(this._onReady, this));
		},

		_onReady: function () {

			var $ctrl = $('[data-ctrl]');

			var ctrl = null;
			var ctrlName = ns.utils.humanize($ctrl.data('ctrl'));

			$ctrl.removeAttr('data-ctrl');

			ns.logger.info('App', 'init controller: ' + ctrlName);

			if (!_.isEmpty(ctrlName)) {

				if (_.isUndefined(ctrlList[ctrlName])) {

					ns.logger.error('App', 'controller not required');

					return;
				}

				ctrl = new ctrlList[ctrlName]();
			}
		}
	};

	return App;
});
